import React, { useState } from 'react';
//import QRCode from 'qrcode.react';

const QuoteCar = () => {
  const [buyerInfo, setBuyerInfo] = useState({});
  const [vehicleDetails, setVehicleDetails] = useState({});
  const [status, setStatus] = useState('');
  const [quoteQR, setQuoteQR] = useState('');

  const handleInputChange = (e) => {
    setBuyerInfo({ ...buyerInfo, [e.target.name]: e.target.value });
  };

  const generateQuoteQR = () => {
    const quoteData = JSON.stringify({ buyerInfo, vehicleDetails });
    setQuoteQR(quoteData);
  };

  return (
    <div>
      <h1>Quote UI</h1>

      {/* Buyer Information Form */}
      <div>
        <h2>Buyer Information</h2>
        <input
          name="firstName"
          placeholder="First Name"
          onChange={handleInputChange}
        />
        <input
          name="lastName"
          placeholder="Last Name"
          onChange={handleInputChange}
        />
        <input
          name="email"
          placeholder="Email"
          onChange={handleInputChange}
        />
        {/* Additional fields */}
      </div>

      {/* Vehicle Details */}
      <div>
        <h2>Vehicle Details</h2>
        <input
          name="currentVehicle"
          placeholder="Current Vehicle"
          onChange={(e) => setVehicleDetails({ ...vehicleDetails, current: e.target.value })}
        />
        {/* VIN Decoder, Options, Pricing */}
      </div>

      {/* QR Code and Notifications */}
      <div>
        <h2>Quote Actions</h2>
        <button onClick={generateQuoteQR}>Generate QR Code</button>
        {/* quoteQR && <QRCode value={quoteQR} />*/}
      </div>
    </div>
  );
};

export default QuoteCar;